<div class="side-preview my-lg-2 mr-sm-2 mr-xl-4 d-none d-lg-block">
    <div class="card mb-2">
        <div class="f-12 pt-1">
            <div class="px-2 pb-1"><span class="fw-500">Tipo laudo:</span>{{ laudo.tipoLaudo }}</div>
            <div class="px-2 pb-1"><span class="fw-500">Config. laudo:</span>  {{ laudo.configLaudo }}</div>
            <div class="px-2 pb-1"><span class="fw-500">Cliente:</span> {{ laudo.cliente }}</div>
            <div class="px-2 pb-1"><span class="fw-500">Vistoriador:</span> {{ laudo.vistoriador }}</div>
            <div class="px-2 pb-1"><span class="fw-500">Modelo:</span> {{ laudo.modelo }} </div>
        </div>
    </div>

    <div class="card mb-2">
        <div class="p-2">
            <app-preview-car
            [car]="car"
              [erro] = "{
                esquerda: esquerda.totalErros,
                direita: direita.totalErros,
                frente: dianteira.totalErros,
                traseira: traseira.totalErros
              }"
            
            ></app-preview-car>
        </div>
    </div>

    <ng-container *ngFor="let c of cards">


        <div *ngIf="c.totalErros>0" class="card mb-2">
            <div class="d-flex justify-content-between">
                <div class="pt-1 px-2 f-12 fw-500">{{c.title}}</div>
            </div>
            <ng-container *ngFor="let e of c.elements" >
                <div *ngIf="e.status>1" class="f-12 pt-1 text-secondary">
                    <div class="px-2 pb-1 d-flex align-items-center"><i class="mdi mdi-circle-medium text-muted f-14"></i>
                        {{ e.label }}: {{e?.option?.label || e.value }}
                    </div>
                </div>
            </ng-container>
            <div *ngIf="c.totalErros==0" class="px-2 pb-1">
                <span class="text-muted f-300 f-12">Nada consta</span>
            </div>
        </div>

    </ng-container>

</div>